import React from 'react'

function MainCard({header, children, ...restProps}) {
  return (
    <div className='bg-cardbg rounded-3xl px-4' {...restProps}> 
      <div className='py-3 border-b'>
        {header}
      </div>
      {
        children
      }
    </div>
  )
}

export default MainCard